import { render, staticRenderFns } from "./curva-title.vue?vue&type=template&id=525b933e&class=text-style&"
import script from "./curva-title.vue?vue&type=script&lang=js&"
export * from "./curva-title.vue?vue&type=script&lang=js&"
import style0 from "./curva-title.vue?vue&type=style&index=0&id=525b933e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports